// extracted by mini-css-extract-plugin
export default {"successLog":"Pdv_successLog__GPa7U","errorLog":"Pdv_errorLog__2wwrQ"};